import { render, staticRenderFns } from "./Weekday.vue?vue&type=template&id=b624d6a2&scoped=true&"
import script from "./Weekday.vue?vue&type=script&lang=js&"
export * from "./Weekday.vue?vue&type=script&lang=js&"
import style0 from "./Weekday.vue?vue&type=style&index=0&id=b624d6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b624d6a2",
  null
  
)

export default component.exports